var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSendIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 1.13568C23.9614 1.21898 23.9077 1.29702 23.8388 1.36568L8.66775 16.4903L12.9537 23.6116C13.1087 23.8692 13.3955 24.0185 13.6961 23.9982C13.9968 23.9778 14.2606 23.7913 14.3793 23.5151L24 1.13568Z",
    fill: "#2A3751"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.53292 15.3589L0.389603 11.086C0.131201 10.9314 -0.0185561 10.6456 0.00184857 10.3458C0.0222533 10.0461 0.20938 9.78304 0.48636 9.6647L22.939 0.0715921C22.8538 0.11021 22.774 0.16445 22.7039 0.234314L7.53292 15.3589Z",
    fill: "#2A3751"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendIcon);
export default __webpack_public_path__ + "static/media/sendIcon.2b77c0eb7447f43830e5e850a35eeb12.svg";
export { ForwardRef as ReactComponent };